module.exports = require("@swa-ui/vacations/src/VacationsPackagesPlacement/VacationsPackagesPlacement.module.scss");